var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 46,
    viewBox: "0 0 176 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H16.1082L24.0727 24.31L32.0373 12H36.1455V34H30.9863V21.9325L25.6301 30.3816H22.5127L17.1592 21.9325V34H12V12Z",
    fill: "#2E6FF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3682 29.735H45.4129L43.798 34H38.4692L47.4245 12H52.7808L61.7361 34H55.983L54.3682 29.735ZM52.7808 25.4701L49.8905 17.8031L47.0003 25.4701H52.7808Z",
    fill: "#2E6FF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3637 25.6056L69.219 29.0598V34H64.0598V12H69.219V22.3652L78.4562 12H84.7759L75.7083 21.9611L85.2603 34H78.8284L72.3665 25.6056H72.3637Z",
    fill: "#2E6FF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.469 12H104.643V16.265H92.6282V20.7463H103.653V25.0113H92.6282V29.735H104.901V34H87.4718V12H87.469Z",
    fill: "#2E6FF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.751 17.6414C117.751 19.1795 116.56 20.3396 114.945 20.3396C113.331 20.3396 112.113 19.1795 112.113 17.6414C112.113 16.1033 113.303 14.9432 114.945 14.9432C116.588 14.9432 117.751 16.1033 117.751 17.6414ZM117.751 28.3586C117.751 29.8967 116.56 31.0568 114.945 31.0568C113.331 31.0568 112.113 29.8967 112.113 28.3586C112.113 26.8205 113.303 25.6604 114.945 25.6604C116.588 25.6604 117.751 26.8205 117.751 28.3586Z",
    fill: "#2E6FF2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.21 34L133.732 27.0629H129.624V34H124.465V12H133.759C139.625 12 143.054 14.9693 143.054 19.5315C143.054 22.5555 141.551 24.8757 138.831 26.0905L144.187 34H138.207H138.21ZM129.624 22.7171H133.535C136.255 22.7171 137.9 21.6092 137.9 19.5315C137.9 17.4537 136.255 16.3458 133.535 16.3458H129.624V22.7171Z",
    fill: "#2E6FF2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.571 12H163.745V16.265H151.73V20.7463H162.755V25.0113H151.73V29.735H164V34H146.571V12Z",
    fill: "#2E6FF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.fb66b2e2026b8d02e2b9ad4f3f4ecb2e.svg";
export { ForwardRef as ReactComponent };